'use client'

import { SignIn } from '@clerk/nextjs'
import { Suspense } from 'react'
import { LoadingSpinner } from '@/components/LoadingSpinner'

const SignInFallback = () => (
    <div className="w-full max-w-sm h-[400px] flex items-center justify-center">
        {/* Optionally add a spinner or just leave it blank for layout */}
        {/* <LoadingSpinner /> */}
    </div>
)

export default function Page() {
    return (
        <div className="min-h-screen w-full flex items-center justify-center bg-background">
            <div className="mx-auto max-w-2xl">
                <div className="text-center">
                    <div className="mt-10 flex justify-center">
                        <Suspense fallback={<SignInFallback />}>
                            <SignIn routing="hash" />
                        </Suspense>
                    </div>
                </div>
            </div>
        </div>
    )
}
